import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'service-validity',
  templateUrl: './service-validity.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class ServiceValidityComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);

  constructor( private translate: TranslateService) { }

  ngOnInit(): void {
  }

  isEmptyAndNull(obj: any) {
    if (!obj)
      return true;
    else if (Object.keys(obj).length === 0) {
      return true;
    } else return false

  }

  getServiceValidity(validityInDays: number): Observable<string> {
    if (validityInDays < 30) {
      if(validityInDays == 1)
       return this.translate.get('REPORTS.REPORT_TEMPLATE.COLUMNS.DAY', {no: validityInDays});
      else
        return this.translate.get('REPORTS.REPORT_TEMPLATE.COLUMNS.DAYS', {no: validityInDays});
    } else {
      const months = Math.floor(validityInDays / 30);
      if(months == 1)
       return this.translate.get('REPORTS.REPORT_TEMPLATE.COLUMNS.MONTH', {no: months});
      else
        return this.translate.get('REPORTS.REPORT_TEMPLATE.COLUMNS.MONTHS', {no: months});
    }
  }

}